<template>
  <div class="flex w-full">
    <div class="flex items-center mr-6">
      <img src="@/images/facebook.svg" class="w-8">
    </div>
    <input class="h-10 p-2 shadow-md font-sans-serif w-full md:w-auto" placeholder="Facebook Link"
      v-model="facebookUrl"
      @change="updateSocial"/>
  </div>
</template>
<script>
import axios from 'axios';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      facebookUrl: '',
    };
  },

  computed: {
    ...mapGetters({
      user: 'auth/user',
    }),
  },

  mounted() {
    this.facebookUrl = this.user.facebook ? this.user.facebook : '';
  },

  methods: {
    updateSocial() {
      axios.put(`/api/users/${this.user.id}`, { facebook: this.facebookUrl });
    },
  },

};
</script>
